import React, { useEffect, useState } from 'react';
import Confetti from 'react-confetti';
import { motion } from 'framer-motion';

const ThankYou = () => {
    const [dimensions, setDimensions] = useState({ width: 0, height: 0 });

    useEffect(() => {
        const updateSize = () => {
            setDimensions({ width: window.innerWidth, height: window.innerHeight });
        };
        updateSize();
        window.addEventListener('resize', updateSize);
        return () => window.removeEventListener('resize', updateSize);
    }, []);

    return (
        <div className="min-h-screen flex items-center justify-center bg-[#F2F1F0] text-[#144E73] relative overflow-hidden">
            <Confetti width={dimensions.width} height={dimensions.height} numberOfPieces={200} />

            <motion.div
                className="text-center p-8 bg-white shadow-lg rounded-lg z-10"
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6 }}
            >
                <h1 className="text-4xl font-bold mb-4">🎉 Thank You!</h1>
                <p className="text-lg">Your reservation has been successfully submitted.</p>
                <p className="mt-2 text-sm text-gray-600">
                    We’ll get back to you shortly. You can continue browsing our site or contact us if needed.
                </p>
                <a
                    href="/"
                    className="inline-block mt-6 px-6 py-2 bg-[#F29E38] text-[#023059] font-semibold rounded-full hover:bg-opacity-90 transition"
                >
                    Return Home
                </a>
            </motion.div>
        </div>
    );
};

export default ThankYou;
